import { HTTP_X_ListLenders_Response } from '@api-new/mortgageservice';
import { createAction, props } from '@ngrx/store';
import { ErrorModel } from '@shared-lib/models/error.model';

export const getLenders = createAction('[LENDERS] Get Lenders');
export const getLendersSuccess = createAction('[LENDERS] Get Lenders Success', props<HTTP_X_ListLenders_Response>());
export const getLendersFailure = createAction('[LENDERS] Get Lenders Failure', props<{ error: ErrorModel }>());
